<template lang="pug">
  app-page(title="Главное следственное управление" )
    app-toolbar(title="Создать исходящее постановление")
    v-form(ref="addDataRequest" v-model="valid")
      .pt-6.sud-block-overlay.light

        app-text-field(v-model="form.caseNumber" label="Номер УД" :rules="[rules.required]")

        v-combobox(v-model="form.extParam.sizo" :items="sizoListF" item-text="title" label="Следственный изолятор" :rules="[rules.required]" outlined light)

        app-select(
          v-if="isCategoriesLoaded"
          v-model="orgCat" 
          :items="gsuCategories" 
          item-text="title" 
          label="Категория" 
          no-data-text="Категории не найдены" 
          persistent-hint hint="Вы можете выбрать категорию, чтобы отфильтровать список организаций"
          @input="filterByCategory"
        )

        app-select(
          v-if="isOrgsLoaded"
          v-model="form.selectedOrganization" 
          :items="orgList" 
          item-text="name" 
          label="Место доставки" 
          persistent-hint hint="Выберите место доставки"
          @input="updateOrgTemplates"
        )

        app-select(
          v-model="type" 
          :items="requestTypes" 
          item-text="title" 
          item-value="id" 
          label="Тип запроса" 
          :rules="[rules.required]"
        )
        
        .template(v-if="type == requestType.local")
          .local.mb-7
            v-btn.mx-0(@click="$refs.localfile.click()") Выберите файл
              v-icon(right dark) attach_file
            input(type="file" style="display: none" ref="localfile" :accept="acceptFormats" @change="onFilePicked" )
            .wrap.mt-1  {{ form.originalName }}

        .template(v-if="type == requestType.template")
          app-select(
            v-model="form.selectedTemplate" 
            :items="orgTemplates" 
            label="Шаблон" 
            item-text="walias" 
            return-object 
            no-data-text="Шаблонов не найдено" 
            @input="onTemplateSelected"
            :rules="[rules.required]"
          )
        
        app-text-field(v-model="form.name" label="Имя документа" :rules="[rules.required]")

        .template(v-if="type == requestType.template")
          app-text-field(v-model="form.extParam.cDate" label="Дата возбуждения УД" :rules="[rules.required, rules.rudate]" v-mask="mask.date")
          v-combobox( v-model="form.extParam.subdivision" :items="subdivision" label="Подразделение за которым числится обвиняемый" :rules="[rules.required]"  outlined light)

          v-row(no-gutters)
            v-col
              app-text-field.mr-2(v-model="form.extParam.uk1" label="Пункт" )
            v-col
              app-text-field.mr-2(v-model="form.extParam.uk2" label="Часть" )
            v-col
              app-text-field(v-model="form.extParam.uk3" label="Статья УК РФ" )

        app-text-field(v-model="form.extParam.accusedFio" label="ФИО обвиняемого" :rules="[rules.required]")
        v-row(no-gutters)
          v-col.mr-2
            app-text-field(v-model="form.extParam.accusedBdate" label="Дата рождения" :rules="[rules.required, rules.rudate]" v-mask="mask.date")
          v-col
            app-text-field.mr-2(v-model="form.extParam.accusedBplace" label="Уроженца" :rules="[rules.required]")
          v-col
            app-text-field(v-model="form.extParam.accusedCitizenship" label="Гражданина" :rules="[rules.required]")

        .template(v-if="type == requestType.template")
          v-combobox(v-if="orgCat != null && orgCat.value != 1" v-model="form.extParam.ruledCourt" :items="courts" label="Наименование суда вынесшее постановление об избрании меры пресечения" :rules="[rules.required]" outlined light)

          app-text-field(v-model="form.extParam.prDate" label="Дата избрания меры пресечения" :rules="[rules.required, rules.rudate]" v-mask="mask.date")

          v-row(no-gutters)
            v-col.mr-2
              app-text-field(v-model="form.extParam.investigatorFio" label="Фамилия и инициалы следователя" :rules="[rules.required]")
            v-col
              app-text-field(v-model="form.extParam.investigatorRank" label="Звание следователя" :rules="[rules.required]")

          //- app-text-field(v-model="form.extParam.initSubdivision" label="Наименование подразделения возбудившего УД" :rules="[rules.required]" )
          v-combobox( v-model="form.extParam.initSubdivision" :items="subdivision" label="Наименование подразделения возбудившего УД" :rules="[rules.required]" outlined light)

          .template(v-if="orgCat != null && (orgCat.value == 2 || orgCat.value == 31)")
            v-combobox( v-model="form.extParam.ivs" :items="ivs" label="Подразделение с ИВС" :rules="[rules.required]" outlined light)
            app-text-field(v-model="form.extParam.ivsAddress" label="Адрес ИВС" :rules="[rules.required]")

          .template(v-if="orgCat != null && orgCat.value == 1")
            v-row(no-gutters)
              v-col.mr-2(cols=8)
                app-text-field(v-model="form.extParam.actDate" label="Дата и время на которое назначено судебное заседание" :rules="[rules.required, rules.rudate]" v-mask="mask.date")
              v-col
                app-text-field.mr-2(v-model="form.extParam.actHour" label="Час" :rules="[rules.required]")
              v-col
                app-text-field(v-model="form.extParam.actMinutes" label="Минуты" :rules="[rules.required]")

            v-row(no-gutters)
              v-col
                app-text-field.mr-2(v-model="form.extParam.judge" label="Фамилия и инициалы судьи" :rules="[rules.required]")
              v-col
                app-text-field(v-model="form.extParam.judgePlace" label="Номер зала заседания" :rules="[rules.required]")
 

          .template(v-else)
            v-row(no-gutters)
              v-col.mr-2
                app-text-field(v-model="form.extParam.actDateStart" label="Начало проведения следственных действий" :rules="[rules.required, rules.rudate]" v-mask="mask.date")
              v-col
                app-text-field(v-model="form.extParam.actDateEnd" label="Окончание проведения следственных действий" :rules="[rules.required, rules.rudate]" v-mask="mask.date")


          .template
            v-row(no-gutters)
              v-col.mr-2(cols="8")
                app-text-field(v-model="form.extParam.executive" label="Должность, звание руководителя, подписывающего электронное постановление" :rules="[rules.required]")
              v-col
                app-text-field(v-model="form.extParam.executiveFio" label="Фамилия и инициалы подписывающего" :rules="[rules.required]")

      .text-right.pt-4
        app-button-action(@click="createRequest" :dark="!isNotReady" :disabled="isNotReady") Сохранить



</template>

<script>

import { mapGetters, mapState, mapMutations } from 'vuex';
import { AppDialogToggable } from '@/components'
import { organizationService } from "@/_services"
import { requestType } from '@/pages/cases/components/constants.js'
import { $_validate_rules } from '@/common/ValidateRules'
import { subdivision, courts, ivs, sizoList } from './constants.js'
import { mask } from 'vue-the-mask' 

export default {
  mixins: [AppDialogToggable, $_validate_rules],
  directives: { mask },

  props: {
    members: null,
  },
  
  data () {
    const defaultForm = Object.freeze({
      selectedTemplate: null,
      originalName: '',
      name: '',
      selectedOrganization: null,
      extParam: {}
    })

    return {
      mask: {
        date: '##.##.####'
      },
      valid: false,
      form: Object.assign({}, defaultForm),
      type: requestType.template,
      requestType,
      defaultForm,
      organizations: [],
      orgTemplates: [],
      orgCat: null,
      subdivision,
      ivs,
      courts,
      sizoList
    }
  },

  watch: {
    $_show (value) {
      if (value) {
        this.orgTemplates=[]
        this.form = Object.assign({}, this.defaultForm)
        this.form.extParam = {}
      }
    }
  },

  computed: {
    ...mapState('organization', [ 'selectedCategory']),
    ...mapGetters('organization', ['orgs','isOrgsLoaded','categories','isCategoriesLoaded']),

    sizoListF() {
      return window.settings.sizoList ? window.settings.sizoList : this.sizoList
    },

    gsuCategories () {
      let cat = []
      this.categories.filter(c => c.show == 1).forEach(c =>{
        if(c.name=="OTHER"){
           c.title= "Районные ИВС (областные)"
           cat.push(c)
           cat.push({name: "mivs", title: "МИВС", value: 21})
           cat.push({name: "givs", title: "Городские ИВС", value: 31})
        } else
           cat.push(c)
      })
      return cat
    },

    header () {
      return 'Запрос'
    },

    orgList() {
      let list =  this.orgs
      if(this.selectedCategory != null) {
         if(this.selectedCategory.name=="mivs")
            list = this.orgs.filter(c => c.alias!=null && c.alias=='mivs')
         else if(this.selectedCategory.name=="givs")
            list = this.orgs.filter(c => c.alias!=null && c.alias=='givs')
         else 
            list = this.orgs.filter(c => c.organizationCategory!=null && c.organizationCategory.value == this.selectedCategory.value && c.alias!='mivs' && c.alias!='givs')
      }
      return list
    },

    acceptFormats () {
      let types = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
      ]
      return types.join(', ')
    },

    isNotReady () {
      if(!this.valid) return true
      return false
    },

    requestTypes () {
      return [
        { title: 'На основе шаблона', id: requestType.template},
        { title: 'Локальный компьютер', id: requestType.local} 
      ]
    },

    caseNumber () {
      return this.form.caseNumber !== undefined ? this.form.caseNumber : ""
    }
  },

  methods: {
    ...mapMutations('organization', [ 'selectCategory']),
    ...mapMutations('gsu', [ 'setLastSendable']),

    filterByCategory(cat) {
      this.selectCategory(cat)
    },

    updateOrgTemplates(item) {
      if(item.alias!=null && item.alias=="mivs")
         this.orgCat = {name: "mivs", title: "МИВС", value: 21}
      else if(item.alias!=null && item.alias=="givs")
         this.orgCat = {name: "givs", title: "Городские ИВС", value: 31}
      else 
         this.orgCat = item.organizationCategory
      organizationService.orgtemplates(item.id)
      .then(data => this.orgTemplates = data ? data : [])
      
    },

    uploadFile () {
      let formData = new FormData();
      formData.append("file", this.$refs.localfile.files[0])

      organizationService.uploadFiles(formData)
      .then(data => this.sendRequest(data))
      .catch(e => console.log(e))
    },

    createRequest () {
      if (this.$refs.addDataRequest.validate()) {
         if (this.type == requestType.local) {
           this.uploadFile()
         } else {
           this.sendRequest()
         }
      }
    },

    sendRequest (fileName = '') {
      let extParam = Object.assign({}, this.form.extParam)
      extParam.uk1 = (extParam.uk1 && extParam.uk1!='') ? "п. " + extParam.uk1 : ""
      extParam.uk2 = (extParam.uk2 && extParam.uk2!='') ? "ч. " + extParam.uk2 : ""
      extParam.uk3 = (extParam.uk3 && extParam.uk3!='') ? "ст. " + extParam.uk3 : ""
      extParam.mailTo = this.form.selectedOrganization.alias=="mivs" ? this.form.selectedOrganization.email : this.form.extParam.sizo.email
      extParam.sizoEmail = this.form.extParam.sizo.email
      extParam.sizoAddress = this.form.extParam.sizo.address
      extParam.sizo = this.form.extParam.sizo.title
      let obj = {
        "fileRequestTemplateId": this.form.selectedTemplate? this.form.selectedTemplate.id : null,
        "organizationId": this.form.selectedOrganization.id,
        "name": this.form.name,
        "caseNumber": this.form.caseNumber,
        "extParam": extParam,
        "fileName": fileName
      }
      
      organizationService.gsuRequest(obj)
        .then((data) => this.toList(data.id))
        .catch(e => console.log(e))
    },

    onFilePicked (e) {
		const files = e.target.files
		if (files[0] !== undefined) {
            this.form.originalName = files[0].name
			this.form.name = files[0].name + " по делу " + this.caseNumber
        }
    },

    onTemplateSelected () {
      this.form.name = this.form.selectedTemplate.name + " по делу " + this.caseNumber
    }, 

    toList (id) {
      this.setLastSendable(id)
      this.$store.dispatch('gsu/LOAD_Ordinances')
      .then(() => this.$router.push({name: 'gsuOrdinances'}))
    }, 

  },
  created() {
    this.$store.dispatch('organization/INIT')
  }
}
</script>

<style scoped>
.light {
  background-color: #ffffff;
  margin-right: 0;
}
</style>
